import CopilotCallSummary from './CopilotCallSummary';
import AutogenerateCopilotCallSummary from './AutogenerateCopilotCallSummary';
import { CALLING_AUTOGENERATE_COPILOT_CALL_SUMMARY } from 'calling-internal-common/constants/CallingGates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CallSummary = ({
  callId,
  usageTracker,
  usageTrackerAppLocationKey,
  gates = []
}) => {
  const isUngatedToAutogenerateCopilotCallSummary = gates.includes(CALLING_AUTOGENERATE_COPILOT_CALL_SUMMARY);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isUngatedToAutogenerateCopilotCallSummary ? /*#__PURE__*/_jsx(AutogenerateCopilotCallSummary, {
      usageTracker: usageTracker,
      callId: callId,
      usageTrackerAppLocationKey: usageTrackerAppLocationKey
    }) : /*#__PURE__*/_jsx(CopilotCallSummary, {
      usageTracker: usageTracker,
      callId: callId,
      usageTrackerAppLocationKey: usageTrackerAppLocationKey
    })
  });
};
export default CallSummary;